import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const mailTemplatesRoute: RouteConfig = {
  path: '',
  name: 'mailTemplates',
  component: () => import(/* webpackChunkName: "MailTemplates" */ '@/views/mainRoute/mailTemplate/List.vue'),
  beforeEnter: (to, from, next) => {
    store
      .dispatch('mailTemplate/list')
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.MAIL_TEMPLATE_CANNOT_LIST }));
  }
};
